const escapeRgx = (term: string): string => {
  return term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const convertTextToRegex = (term: string): RegExp => {
  const scapedTerm = escapeRgx(term);        
  return new RegExp(scapedTerm, 'ig');
}

export function getMatchingParts<T>(
  text: string, 
  term: string, 
  replaceMatch?: (index: number) => T
): (string | T)[] | undefined {
  const rgx = convertTextToRegex(term)
  const parts = text.split(rgx);
  
  if (parts.length > 1) {
    const matches = [];
    let i=0;
    for (i; i < parts.length; i++) {
      const previous = parts[i-1];
      
      if (previous !== undefined) {
        const match = replaceMatch ? replaceMatch(i) : term;
        if (previous === '') {
          matches.push(match);
        } else {
          matches.push(previous, match);
        }
      }
    }

    const last = parts.length-1;
    if (parts[last] !== '') {
      matches.push(parts[last]);
    }

    return matches;
  }
}